import { ChecklistStatus } from '../../common/DocPage.types';

export const StackStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.good,
  markupSupport: ChecklistStatus.good,
  highContrastSupport: ChecklistStatus.pass,
  rtlSupport: ChecklistStatus.pass,
  testCoverage: ChecklistStatus.good
};
